import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card, CardBody, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../contexts/ThemeContext.js";
import { listVouchers } from "../redux/actions/voucherActions.js";
import EditVoucher from "../components/common/EditVoucher.js";
import useBrandDetails from "../hooks/useBrandDetails.js";

const VoucherList = () => {
  const { returnBrandDetail } = useBrandDetails();
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [editData, setEditData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // New state for status filter

  const { vouchers, loading } = useSelector((state) => state.voucherList);

  const handleEdit = (data) => {
    setOpen(true);
    setEditData(data);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const triggerGetList = () => {
    dispatch(listVouchers(currentPage, itemsPerPage, searchTerm, statusFilter)); // Pass statusFilter
  };

  useEffect(() => {
    triggerGetList();
  }, [dispatch, currentPage, itemsPerPage, searchTerm, statusFilter]); // Add statusFilter to dependencies

  useEffect(() => {
    if (vouchers?.data) {
      setDatas(vouchers.data);
      setTotalItems(vouchers.pagination?.totalItems || 0);
    }
  }, [vouchers]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setItemsPerPage(newPerPage);
    setCurrentPage(page);
  };

  const columns = [
    { name: <b>S.No</b>, cell: (row, index) => index + 1 + (currentPage - 1) * itemsPerPage },
    { name: <b>Voucher ID</b>, selector: (row) => row?.voucherId },
    { name: <b>Brand Name</b>, selector: (row) => returnBrandDetail(row?.brandId)?.brandName },
    { name: <b>Seller Name</b>, selector: (row) => row?.userId?.name },
    { name: <b>Email</b>, selector: (row) => row?.userId?.email, wrap: true, width: "200px" },
    { name: <b>Mobile Number</b>, selector: (row) => row?.userId?.mobilenumber },
    { name: <b>Whatsapp Number</b>, selector: (row) => row?.userId?.whatsappnumber },
    { name: <b>Actual Price</b>, selector: (row) => row?.actualPrice },
    { name: <b>Selling Price</b>, selector: (row) => row?.sellingPrice },
    { name: <b>Created At</b>, selector: (row) => new Date(row?.createdAt).toLocaleDateString("en-GB") },
    { name: <b>Expire Date</b>, selector: (row) => new Date(row?.expireDate).toLocaleDateString("en-GB") },
    { name: <b>Description</b>, selector: (row) => row?.description },
    { name: <b>Status</b>, selector: (row) => row?.status || "Active" },
    {
      name: <b>Actions</b>,
      cell: (row) => (
        <span onClick={() => handleEdit(row)}>
          <i className="fa fa-pencil" style={{ color: "green", cursor: "pointer", fontSize: 20 }}></i>
        </span>
      ),
    },
  ];

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col sm="4">
          <h4>Voucher List</h4>
        </Col>
        <Col sm="4">
          <Input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
        <Col sm="4">
          <Input
            type="select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
            <option value="Pending">Pending</option>
            <option value="Hold">Hold</option>
             <option value="Sold">Sold</option>
            {/* Add more status options as per your backend */}
          </Input>
        </Col>
      </Row>

      <Card>
        <CardBody>
          <DataTable
            pagination
            columns={columns}
            data={datas}
            progressPending={loading}
            theme={theme === "dark" ? "darkMode" : "lightMode"}
            paginationServer
            paginationTotalRows={totalItems}
            paginationPerPage={itemsPerPage}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </CardBody>
      </Card>

      <EditVoucher openModal={open} onCloseModal={closeModal} voucher={editData} triggerGetList={triggerGetList} />
    </Container>
  );
};

export default VoucherList;